import { useFieldContext } from './form';
import { Label } from '../ui/Label';
import { Input } from '../ui/Input';
import { FieldInfo } from './FieldInfo';
import { useTranslation } from 'react-i18next';

interface NumberFieldProps {
  label: string;
  placeholder?: string;
  min?: number;
  max?: number;
}

export function NumberField({
  label,
  placeholder,
  min,
  max,
}: NumberFieldProps) {
  const { t } = useTranslation('common');

  const field = useFieldContext<number>();

  return (
    <div>
      <Label htmlFor={label}>{label}</Label>
      <Input
        id={label}
        type="number"
        value={field.state.value?.toString() ?? ''}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(Number(e.target.value))}
        placeholder={placeholder ?? `${t('enter')} ${label}`}
        min={min}
        max={max}
      />

      <FieldInfo field={field} />
    </div>
  );
}
